export default "__VITE_ASSET__CD_6VEtR__"